<template>
  <div class="details-view">
    <cargo-left-right-resize
      :left-style="{flex:'none','min-width': '180px','max-width':'220px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'"
      style="min-height:100%"
    >
      <template v-show="action==='look'" slot="left">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :row-data="rowData"
          class="section"
          style="min-width: 160px;width:100%;height:100%;"
          :check-sub-record="false"
          :check-main-record="false"
          :deselect-main-record="false"
          :deselect-sub-record="false"
          @gridReady="params=>{gridApi=params.api}"
        />
      </template>
      <template slot="right">
        <div class="main-content">
          <div v-if="$store.getters.enableFrontEndPlugin">
            <micro-app
              name="child-sale-role-hide-salesquery"
              :url="$store.getters.frontEndPluginUrl+'/saleRoleHideItem'"
              router-mode="pure"
              destroy
              @datachange="saleRoleHideDataChange"
            />
            <micro-app
              name="child-customer-sales-display-salesquery"
              :url="$store.getters.frontEndPluginUrl+'/customerSalesDisplayItem'"
              router-mode="pure"
              destroy
              @datachange="customerSalesDisplayDataChange"
            />
          </div>
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers">
              <!--返回查询-->
              <el-button no="1" type="primary" @click="goBack">{{ $t('CargoMsg.Cargo_ReturnQuery') }}</el-button>
              <!-- 指令操作按钮 -->
              <template v-for="(item, index) in instructioinBtns">
                <el-button
                  :key="index"
                  :no="item.platformInstructionRuleCode"
                  type="primary"
                  :disabled="!item.allowOperate"
                  @click="onInstructionClick(item)"
                >
                  {{ $selectByLang(item.chineseName, item.englishName, item.japaneseName) }}
                </el-button>
              </template>
              <!--打印-->
              <el-button v-if="activeTabName === 'tabInternalBill' || activeTabName === 'tabCharges'" no="2" type="success" @click="onPrint">{{ $t('SeaExport.print') }}</el-button>
              <!--国外账单打印-->
              <el-button v-if="showOverSeaPrint" no="3" type="success" @click="onPrint">{{ $t('SeaExport.print') }}</el-button>
              <!--销售信息调整-->
              <el-button v-if="editSaleInfo && currentRow && currentRow.lob === 'SE'" no="4" :disabled="(!currentRow || Number(currentRow.jobState) != 0)" type="primary" @click="onEditSaleInfo">{{ $t('CargoMsg.Cargo_EditSaleInfo') }}</el-button>
              <!--申请解锁-->
              <el-button v-if="$checkPermission(['button_ledger'])" no="9" type="primary" @click="toUnlockApply">{{ $t('SeaExport.UnlockApplyBtn') }}</el-button>
            </div>
            <div class="triggers-right">
              <span no="JobState" class="red" style="font-size:14px;">
                {{ ColumnUtils.getJobState(currentRow) }}
                <!-- 「正操作」「预提交」「已提交」「已审核」业务状态存在费用时 进行退关操作后，需要显示为「XXX（有费用退关）」-->
                <font v-if="(currentRow.jobState === 0 || currentRow.jobState === 1 || currentRow.jobState === 2 || currentRow.jobState === 11) && currentRow.shutOut" class="red" style="font-size:14px;margin-left:4px;">({{ $t('Message.HasChargeToShutOut') }})</font>
                <span v-if="currentRow.payableChargeLockedStatus === 1" style="margin-left:6px;">{{ $t('CargoMsg.Cargo_PayableLockedStatusTag') }}<el-tooltip effect="dark" :content="payableChargeLockedTooltip" placement="bottom" :visible-arrow="false"><i class="el-icon-warning" style="cursor:pointer;" /></el-tooltip></span>
              </span>
              <span v-if="currentRow.payableChargeLockedStatus === 1" style="margin-left:6px;">{{ $t('CargoMsg.Cargo_PayableLockedStatusTag') }}<el-tooltip effect="dark" :content="payableChargeLockedTooltip" placement="bottom" :visible-arrow="false"><i class="el-icon-warning" style="cursor:pointer;" /></el-tooltip></span>
              <template v-if="currentRow && currentRow.uuid">
                <span
                  v-if="salesHeaderJobNoDisplay"
                  style="font-size:12px;margin-left:10px;color:unset;"
                >{{ salesHeaderJobNoDisplay }}</span>
                <span style="font-size:12px;margin-left:10px;color:unset;">{{ salesHeaderDocNoDisplay }}</span>
                <span style="font-size:12px;margin-left:10px;color:unset;">{{ salesHeaderCustomerRefNoDisplay }}</span>
              </template>
            </div>
          </div>
          <div class="tabs-container">
            <el-tabs ref="tabs" v-model="activeTabName" type="card" style="width:100%;" @tab-click="handleTabClick">
              <template>
                <template v-if="seUiCustomEnable">
                  <!--基本-->
                  <el-tab-pane v-if="!isSalesForSzfs && seUiCustomShowPageSet.basic" key="seBasicTab" :label="$t('CargoMsg.Cargo_Operation')" :lazy="true" name="basicTab">
                    <basic-tab ref="basicTab" :lob="lob" :master-flag="masterFlag" :context="context" :job="currentRow" :show-ui-custom="true" />
                  </el-tab-pane>
                  <!--订舱-->
                  <el-tab-pane v-if="seUiCustomShowPageSet.vessel" key="seVesselEqTab" :lazy="!isSalesForSzfs" name="tabVesselEq" :label="$t('CargoMsg.Cargo_Booking')">
                    <tab-vessel-eq-UICustom ref="tabVesselEq" :context="context" :action="action" view-source="salesDetail" :is-sales-for-szfs="isSalesForSzfs" />
                  </el-tab-pane>
                </template>
                <template v-else-if="aeUiCustomEnable">
                  <!--基本-->
                  <el-tab-pane v-if="!isSalesForSzfs && aeUiCustomShowPageSet.basic" key="aeBasicTab" :label="$t('CargoMsg.Cargo_Operation')" :lazy="true" name="basicTab">
                    <basic-tab ref="basicTab" :lob="lob" :master-flag="masterFlag" :context="context" :job="currentRow" :show-ui-custom="true" />
                  </el-tab-pane>
                  <!--订舱-->
                  <el-tab-pane v-if="!isSalesForSzfs && aeUiCustomShowPageSet.vessel" key="aeVesselEqTab" :lazy="true" name="tabVesselEq" :label="$t('CargoMsg.Cargo_Booking')">
                    <ae-tab-vessel-eq-UICustom ref="tabVesselEq" :context="context" :action="action" view-source="salesDetail" />
                  </el-tab-pane>
                </template>
                <template v-else>
                  <!--基本-->
                  <el-tab-pane v-if="!isSalesForSzfs" :key="1" :label="$t('CargoMsg.Cargo_Operation')" :lazy="true" name="basicTab">
                    <basic-tab ref="basicTab" :lob="lob" :master-flag="masterFlag" :context="context" :job="currentRow" />
                  </el-tab-pane>
                  <!--订舱-->
                  <el-tab-pane v-if="lob==='SE'" :key="2" :lazy="!isSalesForSzfs" name="tabVesselEq" :label="$t('CargoMsg.Cargo_Booking')">
                    <tab-vessel-eq ref="tabVesselEq" :context="context" :action="action" view-source="salesDetail" :is-sales-for-szfs="isSalesForSzfs" />
                  </el-tab-pane>
                </template>
              </template>
              <el-tab-pane v-if="lob==='IE' && currentRow.containerLoadType === 'TT' && !isSalesForSzfs" :key="30" :lazy="true" name="tabGatheringTrailer" :label="$t('SeaExport.GatheringTrailer')">
                <tab-gathering-trailer ref="tabGatheringTrailer" :context="context" :action="action" />
              </el-tab-pane>
              <el-tab-pane v-if="lob==='IE' && currentRow.containerLoadType === 'CL' && !isSalesForSzfs" :key="31" :lazy="true" name="tabLessThanCarload" :label="$t('SeaExport.WholeVehicleLessThanCarload')">
                <tab-less-than-carload ref="tabLessThanCarload" :context="context" :action="action" />
              </el-tab-pane>
              <el-tab-pane v-if="lob==='IE' && currentRow.containerLoadType === 'IC'" :key="32" :lazy="!isSalesForSzfs" name="tabOrderCar" :label="$t('CargoMsg.Cargo_Booking')">
                <tab-order-car ref="tabOrderCar" :context="context" :action="action" />
              </el-tab-pane>
              <template v-if="seUiCustomEnable">
                <el-tab-pane
                  v-if="(masterFlag || currentRow.signMBL) && seUiCustomShowPageSet.mbl"
                  key="seMBLTab"
                  :lazy="true"
                  name="tabMBL"
                  label="MB/L"
                >
                  <!-- MB/Ltab -->
                  <tab-mbl-UICustom ref="tabMBL" :context="context" :action="action" />
                </el-tab-pane>
                <el-tab-pane
                  v-if="currentRow.typeMBL === 2 && seUiCustomShowPageSet.mbl"
                  key="seMBLSplitTab"
                  :lazy="true"
                  name="tabMBL2"
                  :label="'MB/L' + $t('CargoMsg.Cargo_SplitBL')"
                >
                  <tab-mbl2-UICustom ref="tabMBL2" :context="context" :action="action" />
                </el-tab-pane>
                <el-tab-pane
                  v-if="currentRow.typeMBL === 3 && seUiCustomShowPageSet.mbl"
                  key="seMBLMergeTab"
                  :lazy="true"
                  name="tabMBL2"
                  :label="'MB/L' + $t('SeaExport.MergeAndSingle')"
                >
                  <tab-mbl2-UICustom ref="tabMBL2" :context="context" :action="action" />
                </el-tab-pane>
                <el-tab-pane
                  v-if="currentRow.signHBL && !currentRow.mblOnly && !masterFlag && seUiCustomShowPageSet.hbl"
                  key="seHBLTab"
                  :lazy="true"
                  name="tabHBL"
                  label="HB/L"
                >
                  <tab-hbl-UICustom ref="tabHBL" :context="context" :action="action" />
                </el-tab-pane>
                <el-tab-pane
                  v-if="!currentRow.mblOnly && currentRow.typeHBL === 2 && seUiCustomShowPageSet.hbl"
                  key="seHBLSplitTab"
                  :lazy="true"
                  name="tabHBL2"
                  :label="'HB/L' + $t('CargoMsg.Cargo_SplitBL')"
                >
                  <tab-hbl2-UICustom ref="tabHBL2" :context="context" :action="action" />
                </el-tab-pane>
                <el-tab-pane
                  v-if="!currentRow.mblOnly && currentRow.typeHBL === 3 && seUiCustomShowPageSet.hbl"
                  key="seHBLMergeTab"
                  :lazy="true"
                  name="tabHBL2"
                  :label="'HB/L' + $t('SeaExport.MergeAndSingle')"
                >
                  <tab-hbl2-UICustom ref="tabHBL2" :context="context" :action="action" />
                </el-tab-pane>
                <el-tab-pane
                  v-if="currentRow.virtualHBL && seUiCustomShowPageSet.virtualHbl"
                  key="seSubBillTab"
                  :lazy="true"
                  name="tabSubBill"
                  :label="$t('SeaExport.FormalHbl')"
                >
                  <tab-sub-bill-UICustom ref="tabSubBill" :context="context" :action="action" />
                </el-tab-pane>
              </template>
              <!--仓储/客户门点-->
              <el-tab-pane
                v-if="currentRow && currentRow.lob && !isSalesForSzfs && !seUiCustomEnable"
                :key="5"
                :lazy="true"
                name="warehouseTab"
                :label="$t('CargoMsg.Cargo_WarehouseDoor')"
              >
                <warehouse-tab ref="warehouseTab" :job="currentRow" :lob="currentRow.lob" :context="context" :master-flag="currentRow.masterFlag" view-source="salesDetail" />
              </el-tab-pane>
              <!--装箱-->
              <el-tab-pane
                v-if="currentRow && currentRow.lob !== 'AE' && currentRow.lob !== 'AI' && !isSalesForSzfs"
                :key="6"
                :lazy="true"
                name="containerTab"
                :label="$t('SeaExport.ContainerInfo')"
              >
                <container-tab ref="containerTab" :job="currentRow" :lob="lob" :context="context" :master-flag="masterFlag" view-source="salesDetail" />
              </el-tab-pane>

              <template v-if="seUiCustomEnable">
                <el-tab-pane
                  v-if="currentRow.landTransportation && seUiCustomShowPageSet.trucking"
                  key="seTruckingTab"
                  :lazy="true"
                  name="tabTruckingForSe"
                  :label="$t('SeaExport.Trucking')"
                >
                  <tab-trucking-UICustom ref="tabTruckingForSe" :context="context" :action="action" />
                </el-tab-pane>
                <!-- 目的港派车tab -->
                <el-tab-pane
                  v-if="currentRow.dischargingPortDoor && seUiCustomShowPageSet.dischargingTrucking"
                  key="seDischargingTruckingTab"
                  :lazy="true"
                  name="tabDischargingTrucking"
                  :label="$t('SeaExport.DispatchVehiclesAtDestination')"
                >
                  <tab-discharging-trucking-UICustom ref="tabDischargingTrucking" :context="context" :action="action" />
                </el-tab-pane>
                <!-- 目的港清关数据tab（只读） -->
                <el-tab-pane
                  v-if="currentRow.destPortCustomsClearance"
                  key="tabDestinationCustomsData"
                  :lazy="true"
                  name="tabDestinationCustomsData"
                  :label="$t('SeaExport.PortOfDestinationCustomsClearance')"
                >
                  <tab-destination-customs-data ref="tabDestinationCustomsData" :context="context" :action="action" :force-readonly="true" />
                </el-tab-pane>
                <el-tab-pane
                  v-if="currentRow.customs && seUiCustomShowPageSet.customs"
                  key="seCustomsTab"
                  :lazy="true"
                  name="tabCustomsInfo"
                  :label="$t('SeaExport.CustomsDeclaration')"
                >
                  <!-- 报关tab -->
                  <tab-customs-info-UICustom ref="tabCustomsInfo" :context="context" :action="action" />
                </el-tab-pane>
              </template>

              <!--以下页签是公用的，无需区分业务类型-->
              <template v-if="$checkPermission(['role_SalesQueryModule_charge'])">
                <template v-if="seUiCustomEnable || aeUiCustomEnable">
                  <el-tab-pane
                    v-if="!chargePageSet.hideTabCharge"
                    key="tabCharges"
                    name="tabCharges"
                    :lazy="!isSalesForSzfs"
                    :label="$t('CargoMsg.Cargo_Cost')"
                  >
                    <tab-charges ref="tabCharges" :context="context" :action="action" :adjust="true" view-source="salesDetail" :sale-role-hide="saleRoleHide" :customer-sales-display="customerSalesDisplay" :enable-ui-custom="chargePageSet.arShowInSalesInquiry" />
                  </el-tab-pane>
                  <el-tab-pane
                    v-if="chargePageSet.arAloneShow && $checkPermission(['tab_Charge_chargeReceivable'])"
                    key="tabChargesAr"
                    name="tabChargesAr"
                    :lazy="!isSalesForSzfs"
                    :label="$t('queryJob.FeeReceivable')"
                  >
                    <tab-charges ref="tabChargesAr" :context="context" :action="action" :adjust="true" view-source="salesDetail" :sale-role-hide="saleRoleHide" :customer-sales-display="customerSalesDisplay" tab-name="tabChargesAr" type="ar" :enable-ui-custom="chargePageSet.arShowInSalesInquiry" />
                  </el-tab-pane>
                  <el-tab-pane
                    v-if="chargePageSet.apAloneShow && $checkPermission(['tab_Charge_chargePayable'])"
                    key="tabChargesAp"
                    name="tabChargesAp"
                    :lazy="!isSalesForSzfs"
                    :label="$t('queryJob.CostsPayable')"
                  >
                    <tab-charges ref="tabChargesAp" :context="context" :action="action" :adjust="true" view-source="salesDetail" :sale-role-hide="saleRoleHide" :customer-sales-display="customerSalesDisplay" tab-name="tabChargesAp" type="ap" :enable-ui-custom="chargePageSet.apShowInSalesInquiry" />
                  </el-tab-pane>
                </template>
                <template v-else>
                  <el-tab-pane :key="7" name="tabCharges" :lazy="!isSalesForSzfs" :label="$t('CargoMsg.Cargo_Cost')">
                    <tab-charges ref="tabCharges" :context="context" :action="action" :adjust="true" view-source="salesDetail" :sale-role-hide="saleRoleHide" :customer-sales-display="customerSalesDisplay" />
                  </el-tab-pane>
                </template>
              </template>
              <el-tab-pane v-if="$checkPermission(['role_SalesQueryModule_billTabView']) && !isSalesForSzfs" :key="8" name="tabInternalBill" :lazy="true" :label="$t('CargoMsg.Cargo_DomesticBill')">
                <tab-internal-bill ref="tabInternalBill" :context="context" :action="action" view-source="salesDetail" />
              </el-tab-pane>
              <el-tab-pane v-if="$checkPermission(['role_SalesQueryModule_BillingPrint']) && !isSalesForSzfs" :key="9" name="tabOverseaBill" :lazy="true" :label="$t('CargoMsg.Cargo_InternationalBill')">
                <tab-oversea-bill ref="tabOverseaBill" :context="context" :action="action" view-source="salesDetail" />
              </el-tab-pane>
              <el-tab-pane v-if="!isSalesForSzfs" :key="10" name="tabFile" :lazy="true" :label="$t('SeaExport.DocumentCirculation')">
                <tab-file ref="tabFile" :context="context" :show-button="false" view-source="salesDetail" />
              </el-tab-pane>
              <el-tab-pane v-if="!isSalesForSzfs" :key="11" name="salesWarehouseIn" :lazy="true" :label="$t('SeaExport.CargoInfo')">
                <sales-warehouse-in ref="salesWarehouseIn" :context="context" :action="action" view-source="salesDetail" />
              </el-tab-pane>
              <el-tab-pane v-if="!isSalesForSzfs" :key="12" name="tabAdvanceCharge" :lazy="true" :label="$t('CargoMsg.Cargo_AdvanceChargeInfo')">
                <tab-advance-charge ref="tabAdvanceCharge" :context="context" :action="action" :adjust="false" view-source="salesDetail" />
              </el-tab-pane>
              <el-tab-pane :key="13" name="tabSopState" :lazy="true" :label="$t('CargoMsg.Cargo_BusinessStatus')">
                <tab-sop-state ref="tabSopState" :context="context" :action="action" view-source="salesDetail" />
              </el-tab-pane>
              <template v-if="seUiCustomEnable">
                <el-tab-pane
                  v-if="!masterFlag && currentRow.cargoType && currentRow.cargoType !== 'GC' && seUiCustomShowPageSet.specialGoods"
                  key="seSpecialGoodsTab"
                  :lazy="true"
                  name="tabSpecialGoods"
                  :label="$t('SpecialGoods.label')"
                >
                  <tab-special-goods-UICustom ref="tabSpecialGoods" :context="context" :action="action" />
                </el-tab-pane>
              </template>
              <template v-if="$checkPermission(['role_SalesQueryModule_FileTab'])">
                <template v-if="seUiCustomEnable">
                  <el-tab-pane v-if="seUiCustomShowPageSet.fileHistory" key="seFileHistoryTab" name="tabFileHistory" :lazy="true" :label="$t('CargoMsg.Cargo_FileHistory')">
                    <tab-file-history ref="tabFileHistory" :context="context" view-source="salesDetail" />
                  </el-tab-pane>
                </template>
                <template v-else>
                  <el-tab-pane :key="14" name="tabFileHistory" :lazy="true" :label="$t('CargoMsg.Cargo_FileHistory')">
                    <tab-file-history ref="tabFileHistory" :context="context" view-source="salesDetail" />
                  </el-tab-pane>
                </template>
              </template>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <!-- 打印报表对话框 -->
    <cargo-template-select-dialog
      ref="templateSelectorDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 销售信息调整弹窗 -->
    <el-dialog
      v-if="saleInfoDialog.visible"
      v-el-drag-dialog
      :visible.sync="saleInfoDialog.visible"
      :title="$t('CargoMsg.Cargo_EditSaleInfo')"
      width="360px"
      :close-on-click-modal="false"
    >
      <el-form label-width="85px" label-position="left">
        <el-form-item :label="$t('SeaExport.UserDefinedField1')">
          <el-input v-model="saleInfoDialog.userDefinedField1" no="5" type="textarea" :rows="5" style="width:195px;" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.quotationNum')">
          <el-input v-model="saleInfoDialog.quotationNum" no="6" style="width:195px;" />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="7" type="primary" @click="toEditSaleInfoConfirm">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="8" @click="saleInfoDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 费用解锁申请弹窗 -->
    <unlock-apply-dialog v-if="unlockApplyDialog.visible" :visible.sync="unlockApplyDialog.visible" :selected-jobs="[currentRow]" @success="onUnlockApplySuccess" />
    <!-- 自定义表单窗口 -->
    <custom-form-window ref="customFormWindow" @instructionCallback="onInstructionCallback" />
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import DateUtils from '@/utils/dateUtils'
import { SalesQueryWorkspaceContext } from './salesQueryWorkspaceContext'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import tabContainer from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabContainer'
import tabLclContainer from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabLclContainer'
import salesWarehouseIn from '@/views/cargo/v0/Sales/components/salesQuery/tabs/salesWarehouseIn'
import basicTab from '@/views/cargo/v0/Sales/components/salesQuery/tabs/basicTab'
import containerTab from '@/views/cargo/v0/Sales/components/salesQuery/tabs/containerTab'
import warehouseTab from '@/views/cargo/v0/Sales/components/salesQuery/tabs/warehouseTab'
import tabVesselEq from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabVesselEq'
import tabCharges from '@/components/Cargo/Job/booking/tabs/tabCharges'
import tabInternalBill from '@/components/Cargo/Job/booking/tabs/tabInternalBill'
import tabOverseaBill from '@/components/Cargo/Job/booking/tabs/tabOverseaBill'
import tabAdvanceCharge from '@/components/Cargo/Job/booking/tabs/tabAdvanceCharge'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import tabSopState from '@/components/Cargo/Job/booking/tabs/tabSopState'
import tabFile from '@/components/Cargo/Job/booking/tabs/tabFile'
import tabVesselEqUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabVesselEqUICustom'
import tabMblUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabMBLUICustom'
import tabMbl2UICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabMBL2UICustom'
import tabHblUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabHBLUICustom'
import tabHbl2UICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabHBL2UICustom'
import tabSubBillUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabSubBillUICustom'
import tabTruckingUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabTruckingUICustom'
import tabDischargingTruckingUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabDischargingTruckingUICustom'
import tabDestinationCustomsData from '@/views/cargo/v0/Sales/components/remoteBooking/tabs/tabDestinationCustomsData'
import tabCustomsInfoUICustom from '@/components/Cargo/Job/booking/tabs/tabCustomsInfoUICustom'
import tabSpecialGoodsUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabSpecialGoodsUICustom'
import aeTabVesselEqUICustom from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabVesselEqUICustom'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import locationImg from '@/assets/location24.png'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import tabBookingFcl from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCL'
import tabBookingMaster from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingMaster'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import CargoTemplateSelectDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { findLclSlavesForMasterUuid, updateJobFields } from '@/api/booking/job'
import TabGatheringTrailer from '@/views/cargo/v0/Integrated/components/booking/tabs/tabGatheringTrailer'
import TabLessThanCarload from '@/views/cargo/v0/Integrated/components/booking/tabs/tabLessThanCarload'
import TabOrderCar from '@/views/cargo/v0/Integrated/components/booking/tabs/tabOrderCar'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import microApp from '@micro-zoe/micro-app'
import { getJobInstructions } from '@/api/sysManage/uiCustom'
import CustomFormWindow from '@/components/Cargo/Job/customFormWindow'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import StrUtils from '@/utils/StrUtils'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import UnlockApplyDialog from '@/views/cargo/v0/SeaExport/components/booking/unlockApplyDialog'

export default {
  name: 'SalesQueryWorkspace',
  components: {
    TabOrderCar,
    TabLessThanCarload,
    TabGatheringTrailer,
    CargoTemplateSelectDialog,
    tabBookingFcl, tabBookingMaster, tabFile, warehouseTab,
    basicTab, containerTab, tabVesselEq, tabCharges, tabInternalBill, tabOverseaBill,
    tabAdvanceCharge, tabFileHistory, tabSopState, salesWarehouseIn,
    DropUploader, cargoAdvanceSelect, cargoLeftRightResize,
    tabContainer, tabLclContainer, CustomFormWindow, UnlockApplyDialog,
    tabVesselEqUICustom, tabMblUICustom, tabMbl2UICustom, tabHblUICustom, tabHbl2UICustom, tabSubBillUICustom, tabTruckingUICustom, tabDischargingTruckingUICustom, tabDestinationCustomsData, tabCustomsInfoUICustom, tabSpecialGoodsUICustom, aeTabVesselEqUICustom
  },
  props: {
    parentContext: {
      type: Object,
      required: true
    },
    isSalesForSzfs: { type: Boolean, default: false } // 深圳丰收销售专用
  },
  data() {
    return {
      ColumnUtils,
      tabsRenderedSet: new Set(), // 已经渲染操作过的tabs
      locationImg,
      selectTypeNames: TYPE_NAMES,
      context: new SalesQueryWorkspaceContext(this.parentContext),
      SystemConstants,
      privilege: {
        seBooking: {
          containersLayer: this.$checkPermission(['tab_SEBooking_ContainersLayer']),
          lclManagerLayer: this.$checkPermission(['tab_SEBooking_LclManagerLayer'])
        }
      },
      sopTooltipOffset: 0,
      action: 'look',
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressContextMenu: true,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          flex: 1,
          tooltip: (params) => {
            return params.data ? params.data.jobNo : ''
          },
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              return `<span>${params.value}</span>`
            }
          },
          suppressMenu: true
        },
        columnDefs: [],
        context: {
          componentParent: this
        },
        onCellFocused: this.handleCellFocused
      },
      rowData: [],
      gridApi: null,
      currentRow: {},
      pendTabSet: new Set(),
      isRefresh: true,
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaExportJob(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      activeTabName: '',
      saleInfoDialog: {
        visible: false,
        userDefinedField1: '', // 船司约号
        quotationNum: '' // 报价单号
      },
      unlockApplyDialog: {
        visible: false
      },
      saleRoleHideData: { // 子应用销售角色移除搜索条件和显示字段
        viewSource: 'SalesQuery',
        hide: false
      },
      saleRoleHide: false,
      customerSalesDisplayData: { // 销售角色可选结算对象范围外的显示
        viewSource: 'RemoteBooking',
        notDisplay: false
      },
      customerSalesDisplay: false,
      instructioinBtns: [], // 指令按钮列表
      editSaleInfo: false,
      seChargePageSet: { hideTabCharge: false, arAloneShow: false, apAloneShow: false, arShowInSalesInquiry: true, apShowInSalesInquiry: false }, // 海运订舱费用页签设置
      aeChargePageSet: { hideTabCharge: false, arAloneShow: false, apAloneShow: false, arShowInSalesInquiry: true, apShowInSalesInquiry: false }, // 空运订舱费用页签设置
      seUiCustomShowPageSet: { // 海运订舱UI自定义显示页签设置
        basic: false,
        vessel: false,
        mbl: false,
        hbl: false,
        virtualHbl: false,
        trucking: false,
        dischargingTrucking: false,
        customs: false,
        specialGoods: false,
        fileHistory: false
      },
      aeUiCustomShowPageSet: { // 空运订舱UI自定义显示页签设置
        basic: false,
        vessel: false
      }
    }
  },
  computed: {
    user() {
      return this.context.user
    },
    office() {
      return this.context.office
    },
    config() {
      return this.context.config
    },
    masterFlag() {
      return this.currentRow.masterFlag || false
    },
    isLclMaster() {
      return !!this.currentRow.lclMasterUuid
    },
    lob() {
      return this.currentRow.lob || 'SE'
    },
    sideBar() {
      return this.$store.getters.sidebar.opened
    },
    // 国外账单打印
    showOverSeaPrint() {
      return this.activeTabName === 'tabOverseaBill' && this.$checkPermission(['button_billTab_overseaBillingPrint'])
    },
    seUiCustomEnable() {
      return this.lob === 'SE' && this.$store.state.uiCustom.enable
    },
    aeUiCustomEnable() {
      return this.lob === 'AE' && this.$store.state.uiCustom.enable
    },
    chargePageSet() {
      switch (this.lob) {
        case 'SE':
          return this.seChargePageSet
        case 'AE':
          return this.aeChargePageSet
        default:
          return { hideTabCharge: false, arAloneShow: false, apAloneShow: false, arShowInSalesInquiry: true, apShowInSalesInquiry: false }
      }
    },
    /** 工具栏与海出对齐：纯业务号 + 主单号/运单号（空为「-」，空运格式化） */
    salesHeaderJobNoDisplay() {
      const job = this.currentRow
      if (!job || !job.jobNo) return ''
      const s = String(job.jobNo).trim()
      return s
    },
    salesHeaderDocNoDisplay() {
      const job = this.currentRow
      if (!job) return ''
      const raw =
        job.mbl != null && String(job.mbl).trim() !== ''
          ? job.mbl
          : job.MBL_NO != null
            ? job.MBL_NO
            : ''
      const s = String(raw).trim()
      if (!s) return '-'
      const lob = job.lob || 'SE'
      if (lob === 'AE' || lob === 'AI') {
        return AirExportUtils.mawbNoDispalyFormat(s) || '-'
      }
      return StrUtils.toHalfwordUpperCase(s) || s
    },
    payableChargeLockedTooltip() {
      const details = []
      const person = ColumnUtils.getPayableChargeLockedPerson(this.currentRow)
      const lockedAt = this.currentRow.payableChargeLockedDate ? DateUtils.formatStandardDateTime(this.currentRow.payableChargeLockedDate) : ''
      if (person) {
        details.push(`${this.$t('CargoMsg.Cargo_PayableFeeLockPerson')}：${person}`)
      }
      if (lockedAt) {
        details.push(`${this.$t('CargoMsg.Cargo_PayableFeeLockTime')}：${lockedAt}`)
      }
      return details.join('\n')
    },
    salesHeaderCustomerRefNoDisplay() {
      const job = this.currentRow
      if (!job || !job.customerRefNo || String(job.customerRefNo).trim() === '') return '-'
      return String(job.customerRefNo).trim()
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        if (this.$store.state.uiCustom.enable) {
          this.loadPageSet()
        }
        this.initConfig()
      }
    }
  },
  async created() {
    await this.context.prepareData()
    this.initConfig()
  },
  beforeMount() {
    if (this.$store.state.uiCustom.enable) {
      this.loadPageSet()
    }
  },
  methods: {
    async initConfig() {
      await cache.load(cacheName.CONFIG)
      this.editSaleInfo = Number(cache.config.get('EditSaleInfo')) === 1
    },
    handleCellFocused(e) {
      if (!e.column) return
      this.gridApi.clearFocusedCell()
      const { rowsToDisplay } = e.api.getModel()
      const curNode = rowsToDisplay[e.rowIndex]
      curNode.setSelected(true)
      this.gridApi.ensureIndexVisible(curNode.rowIndex)
      this.showDetail(curNode.data)
    },
    async showDetail(oneRowData) {
      await this.onShow('look', [], oneRowData)
    },
    loadPageSet() {
      this.seChargePageSet = UICustomUtil.getChargePageSet(UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE)
      this.aeChargePageSet = UICustomUtil.getChargePageSet(UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE)
      this.seUiCustomShowPageSet = {
        basic: UICustomUtil.getSalesInquiryPageShowFlag(UICustomConstants.SEA_BOOKING_BASIC),
        vessel: UICustomUtil.getSalesInquiryPageShowFlag(UICustomConstants.SEA_BOOKING_VESSEL),
        mbl: UICustomUtil.getSalesInquiryPageShowFlag(UICustomConstants.SEA_BOOKING_MBL),
        hbl: UICustomUtil.getSalesInquiryPageShowFlag(UICustomConstants.SEA_BOOKING_HBL),
        virtualHbl: UICustomUtil.getSalesInquiryPageShowFlag(UICustomConstants.SEA_BOOKING_VIRTUAL_HBL),
        trucking: UICustomUtil.getSalesInquiryPageShowFlag(UICustomConstants.SEA_BOOKING_TRUCKING),
        dischargingTrucking: UICustomUtil.getSalesInquiryPageShowFlag(UICustomConstants.SEA_BOOKING_DISCHARGING_TRUCKING),
        customs: UICustomUtil.getSalesInquiryPageShowFlag(UICustomConstants.SEA_BOOKING_CUSTOMS),
        specialGoods: UICustomUtil.getSalesInquiryPageShowFlag(UICustomConstants.SEA_BOOKING_SPECIAL_GOODS),
        fileHistory: UICustomUtil.getSalesInquiryPageShowFlag(UICustomConstants.SEA_BOOKING_FILE_HISTORY)
      }
      this.aeUiCustomShowPageSet = {
        basic: UICustomUtil.getSalesInquiryPageShowFlag(UICustomConstants.AIR_BOOKING_BASIC),
        vessel: UICustomUtil.getSalesInquiryPageShowFlag(UICustomConstants.AIR_BOOKING_VESSEL)
      }
    },
    // tab页签切换
    handleTabClick() {
      this.$nextTick(() => {
        const oldSize = this.tabsRenderedSet.size
        this.tabsRenderedSet.add(this.activeTabName)
        const isRefresh = this.tabsRenderedSet.size > oldSize
        this.$refs[this.activeTabName].onShow(this.currentRow, isRefresh)
      })
    },
    // 左侧切换job
    async onShow(action, treeData, oneRowData) {
      this.loading = getLoading4Cxt(this)
      this.toRenderTreeGrid(treeData, oneRowData.uuid)
      this.currentRow = oneRowData
      this.tabsRenderedSet.clear()
      await this.getAndSetJobDetail().then(() => {
        // 因除海出外，其他业务无订舱页签，所以切换业务时，需做控制  空运无装箱页签
        if (!this.activeTabName || this.activeTabName === '0' || (this.activeTabName === 'tabVesselEq' && this.lob !== 'SE') || (this.activeTabName === 'containerTab' && (this.lob === 'AE' || this.lob === 'AI')) || (this.activeTabName === 'tabSopState')) {
          this.activeTabName = 'basicTab'
        }
        // CARGO-47353 远程订舱&销售查询 限制销售查看供应商信息
        if (this.isSalesForSzfs) {
          if (this.lob === 'SE') {
            this.activeTabName = 'tabVesselEq'
          } else if (this.lob === 'IE' && this.currentRow.containerLoadType === 'IC') {
            this.activeTabName = 'tabOrderCar'
          } else {
            this.activeTabName = 'tabCharges'
          }
        }
        this.$nextTick(() => {
          const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
          if (activePanes && activePanes.length === 0) {
            this.activeTabName = this.getDefaultActiveName()
          }
          this.handleTabClick()
        })
      }).catch(() => {
        this.$message.warning(this.$t('Message.FailedOpenSalesQueryDetails'))
      }).finally(() => {
        this.loading.close()
      })
      this.loadInstructionBtns()
    },
    getDefaultActiveName() {
      const firstPane = this.$refs['tabs'].panes[0]
      return firstPane ? firstPane.name : ''
    },
    // 加载指令按钮
    async loadInstructionBtns() {
      const useHqSet = UICustomUtil.getUseHqSet(UICustomConstants.SALES_INQUIRY_SE_BASIC, this.$store.getters.currentOfficeId)
      const res = await getJobInstructions({
        pageType: UICustomConstants.SALES_INQUIRY_SE_BASIC,
        branchId: this.$store.getters.currentOfficeId,
        useHqSet,
        jobKey: this.currentRow.uuid,
        lob: this.currentRow.lob
      })
      this.instructioinBtns = res.data
    },
    // 设置选中行
    toRenderTreeGrid(treeData, locationUuid) {
      this.gridOptions.api.deselectAll()
      this.gridApi.clearFocusedCell()
      // 更新左侧树
      if (treeData && treeData.length) {
        this.rowData = [...treeData]
      }
      this.$nextTick(() => {
        this.gridOptions.api.forEachNode(node => {
          if (node.data.uuid === locationUuid) {
            node.setSelected(true)
            this.gridApi.ensureIndexVisible(node.rowIndex)
          }
        })
      })
    },
    // 返回
    goBack() {
      this.activeTabName = 'basicTab'
      this.$emit('back', this.isRefresh)
    },
    // 不同业务类型获取对应的业务信息
    async getAndSetJobDetail() {
      // 因海出页签的内部特殊性，海出单独处理
      if (this.lob === 'SE') {
        const seJob = { uuid: this.currentRow.uuid }
        await new SeaExportJob(seJob).loadJobRelated({
          job: true,
          seaEQ: true,
          lclSlaves: this.masterFlag,
          charges: this.masterFlag,
          warehouseIn: this.masterFlag,
          warehouseInfo: true,
          trucking: true,
          lclMaster: !this.masterFlag,
          seaCargoDoc: !this.masterFlag,
          containerUsages: true,
          containers: true,
          cargoBulkDetail: !this.masterFlag,
          surchargeTerms: !this.masterFlag,
          destPortCustomsDataList: true
        })
        Object.assign(this.currentRow, seJob)
      } else if (this.lob === 'AE') {
        const aeJob = { uuid: this.currentRow.uuid }
        await new AirExportJob(aeJob).loadJobRelated({
          job: true,
          cargoDoc: true,
          airCargoDoc: true,
          lclSlaves: this.masterFlag
        })
        Object.assign(this.currentRow, aeJob)
      } else if (this.lob === 'AI') {
        const aiJob = { uuid: this.currentRow.uuid }
        await new AirImportJob(aiJob).loadJobRelated({
          job: true,
          masterJob: !this.masterFlag,
          lclSlaves: this.masterFlag
        })
        Object.assign(this.currentRow, aiJob)
      } else if (this.lob === 'SI') {
        const siJob = { uuid: this.currentRow.uuid }
        await new SeaImportJob(siJob).loadJobRelated({
          job: true,
          seaEQ: true,
          lclSlaves: this.currentRow.masterFlag,
          charges: true,
          warehouseIn: this.currentRow.masterFlag,
          warehouseInfo: true,
          trucking: true,
          lclMaster: !this.currentRow.masterFlag,
          seaCargoDoc: !this.currentRow.masterFlag,
          containerUsages: true,
          containers: true,
          surchargeTerms: !this.currentRow.masterFlag
        })
        Object.assign(this.currentRow, siJob)
        // 非主票 组装 containers.containerUsage  同 job.containerUsages 指向同一usage
        if (!this.currentRow.masterFlag) {
          ContainerUtil.buildContainerUsages(this.currentRow)
        }
      } else if (this.lob === 'RE' || this.lob === 'RI') {
        const reJob = { uuid: this.currentRow.uuid }
        await new RailwayExportJob(reJob).loadJobRelated({
          job: true,
          seaEQ: true,
          lclSlaves: this.masterFlag,
          lclMaster: !this.masterFlag,
          charges: true,
          warehouseIn: true,
          warehouseInfo: true,
          trucking: true,
          containerUsages: true,
          containers: true,
          cargoBulkDetail: !this.masterFlag,
          surchargeTerms: !this.masterFlag
        })
        Object.assign(this.currentRow, reJob)
        if (!reJob.masterFlag) {
          ContainerUtil.buildContainerUsages(this.currentRow)
        }
      } else if (this.lob === 'IE') {
        const ieJob = { uuid: this.currentRow.uuid }
        await new IntegratedJob(ieJob).loadJobRelated({
          job: true,
          seaEQ: true,
          charges: true,
          warehouseIn: true,
          warehouseInfo: true,
          trucking: true,
          truckingInfoPod: true,
          containerUsages: true,
          containers: true
        })
        Object.assign(this.currentRow, ieJob)
      }
      // CARGO-50323 销售查询模块，拼箱业务销售不是自己不能看到
      // 组合权限查看
      if (this.masterFlag) {
        await findLclSlavesForMasterUuid({ masterUuid: this.currentRow.uuid, branchId: this.$store.getters.currentOfficeId }).then(res => {
          this.currentRow.lclSlaves = res.data
        })
      }
    },

    // 打印
    onPrint() {
      this.$nextTick(async() => {
        // 每个页签的参数
        const params = await this.$refs[this.activeTabName].getPrintData() || null
        if (!params) return
        // 公共参数
        if (!Object.prototype.hasOwnProperty.call(params, 'jobuuid') || !params.jobuuid) {
          params.jobuuid = this.currentRow.uuid
        }
        if (!Object.prototype.hasOwnProperty.call(params, 'JOB_UUID') || !params.JOB_UUID) {
          params.JOB_UUID = this.currentRow.uuid
        }
        this.templateSelectorDialog.ctx = Object.prototype.hasOwnProperty.call(params, 'ctx') ? params.ctx : null
        if (Object.prototype.hasOwnProperty.call(params, 'ctx')) delete params.ctx
        this.templateSelectorDialog.category = params.category
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        await this.onPrintCallback(params)
        this.templateSelectorDialog.visible = true
      })
    },
    // 组装打印回调函数 优先取 params 里面的回调，再取页签中的回调，这样修改是为了满足国外账单的特殊情况
    onPrintCallback(params) {
      if (Object.prototype.hasOwnProperty.call(params, 'prePrintCallback')) {
        this.prePrintCallback = params.prePrintCallback
        delete params.prePrintCallback
      } else {
        this.prePrintCallback = this.$refs[this.activeTabName].prePrintCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'printedCallback')) {
        this.printedCallback = params.printedCallback
        delete params.printedCallback
      } else {
        this.printedCallback = this.$refs[this.activeTabName].printedCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'v2CheckCallback')) {
        this.v2CheckCallback = params.v2CheckCallback
        delete params.v2CheckCallback
      } else {
        this.v2CheckCallback = this.$refs[this.activeTabName].v2CheckCallback || null
      }
    },
    // 发起费用解锁申请（不限业务类型）
    toUnlockApply() {
      if (!this.currentRow || !this.currentRow.uuid) {
        return
      }
      if (this.currentRow.receivableChargeLockedStatus !== 1 && this.currentRow.payableChargeLockedStatus !== 1) {
        this.$message.warning(this.$t('SeaExport.UnlockApplyChargeNotLocked'))
        return
      }
      this.unlockApplyDialog.visible = true
    },
    // 解锁申请提交成功（审批期间订单保持锁定，无需刷新锁定状态；成功提示与关弹窗由弹窗组件内部完成）
    onUnlockApplySuccess() {},
    // 销售信息调整
    onEditSaleInfo() {
      if (!this.currentRow || this.currentRow.lob !== 'SE' || Number(this.currentRow.jobState) !== 0) {
        return
      }
      this.saleInfoDialog.userDefinedField1 = this.currentRow.userDefinedField1 || ''
      this.saleInfoDialog.quotationNum = this.currentRow.quotationNum || ''
      this.saleInfoDialog.visible = true
    },
    // 确认调整销售信息
    toEditSaleInfoConfirm() {
      this.loading = getLoading()
      const obj = {}
      obj.jobUuid = this.currentRow.uuid
      obj.userDefinedField1 = this.saleInfoDialog.userDefinedField1
      obj.quotationNum = this.saleInfoDialog.quotationNum
      obj.lob = 'SE'
      updateJobFields(obj).then(res => {
        if (res.data >= 2) {
          this.currentRow.userDefinedField1 = obj.userDefinedField1
          this.currentRow.quotationNum = obj.quotationNum
        }
        this.loading.close()
        this.saleInfoDialog.visible = false
        this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
      }).finally(() => {
        this.saleInfoDialog.visible = false
        this.loading.close()
      })
    },
    setSaleRoleHideData() {
      microApp.forceSetData('child-sale-role-hide-salesquery', this.saleRoleHideData)
    },
    saleRoleHideDataChange(e) {
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setSaleRoleHideData()
        } else {
          this.saleRoleHide = e.detail.data.hide
        }
      }
    },
    setCustomerSalesDisplayData() {
      microApp.forceSetData('child-customer-sales-display-salesquery', this.customerSalesDisplayData)
    },
    customerSalesDisplayDataChange(e) {
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setCustomerSalesDisplayData()
        } else {
          this.customerSalesDisplay = e.detail.data.notDisplay
        }
      }
    },
    onInstructionClick(item) {
      if (item.platformInstructionRuleCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_CUSTOM_FORM.code) {
        this.$refs.customFormWindow.onShowOfUI(item, this.currentRow)
      }
    },
    onInstructionCallback(data) {
      this.loadInstructionBtns()
      if (data.platformInstructionCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_CUSTOM_FORM.code) {
        this.showDetail(this.currentRow)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.operations{
  justify-content: flex-start;
  align-items: center;
  .triggers{
    flex-grow: 0;
  }
  .triggers-right{
    height: 100%;
    line-height: 28px;
    border-left: 2px solid #FFF;
    margin-left: 10px;
    padding-left: 6px;
    white-space: nowrap;
    display: flex;
  }
}
</style>
